import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import {
  OrganizationVaProfile,
  VaBackground,
  VaBackgroundDetailsField,
} from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import { DefaultBackgroundQuestions } from "features/Auth/VAOnboarding/VaProfileForm/Background/schema";
import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../../styles";

interface Props {
  organizationVaProfile: OrganizationVaProfile | null;
  setOrganizationVaProfile: Dispatch<
    SetStateAction<OrganizationVaProfile | null>
  >;
}

const BackgroundForm = ({
  organizationVaProfile,
  setOrganizationVaProfile,
}: Props) => {
  const background: VaBackground =
    organizationVaProfile?.backgroundDetails || DefaultBackgroundQuestions;

  const onChange = (e: CustomEvent) => {
    const { name, value } = e.target;
    setOrganizationVaProfile((prev) => {
      const copy = makeDeepCopy(prev);
      if (!copy.backgroundDetails) {
        copy.backgroundDetails = background;
      }
      copy.backgroundDetails[name]["answer"] = value;
      return copy;
    });
  };

  const renderBackgroundQuestion = (
    fieldName: VaBackgroundDetailsField,
    rows?: number,
  ) => {
    return (
      <Grid item xs={12}>
        <FormHelperText>{background?.[fieldName]?.question}</FormHelperText>
        <TextField
          sx={styles.textField}
          fullWidth
          name={fieldName}
          placeholder={"Type your answer here..."}
          onChange={onChange}
          value={background?.[fieldName]?.answer}
          multiline
          rows={rows || 3}
        />
      </Grid>
    );
  };

  return (
    <>
      <Typography sx={{ mb: 2 }}>
        <strong>
          ❗ Don't worry about how you write things; we use copywriters to make
          everything sound polished. Feel free to ramble, write in bullet
          points, or write an essay. It's better to write more than less.{" "}
        </strong>
      </Typography>

      {Object.keys(background || {}).map((fieldName) => {
        return renderBackgroundQuestion(
          fieldName as VaBackgroundDetailsField,
          fieldName === VaBackgroundDetailsField.other ? 6 : 3,
        );
      })}
    </>
  );
};

export default BackgroundForm;
